import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertsPanel = () => {
  const alerts = [
    {
      id: 1,
      type: 'inventory',
      title: 'Low Stock Alert',
      message: 'Gaming Mouse inventory is below threshold (8 units remaining)',
      severity: 'warning',
      timestamp: '5 minutes ago',
      action: 'Restock Now'
    },
    {
      id: 2,
      type: 'order',
      title: 'Pending Orders',
      message: '3 orders require immediate attention for processing',
      severity: 'error',
      timestamp: '15 minutes ago',
      action: 'Review Orders'
    },
    {
      id: 3,
      type: 'customer',
      title: 'Customer Inquiry',
      message: 'New support ticket from premium customer Sarah Johnson',
      severity: 'info',
      timestamp: '1 hour ago',
      action: 'Respond'
    }
  ];

  const getAlertIcon = (type) => {
    switch (type) {
      case 'inventory':
        return 'Package';
      case 'order':
        return 'ShoppingCart';
      case 'customer':
        return 'MessageCircle';
      default:
        return 'Bell';
    }
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'error':
        return 'text-error bg-error/10 border-error/20';
      case 'warning':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'info':
        return 'text-accent bg-accent/10 border-accent/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getActionVariant = (severity) => {
    switch (severity) {
      case 'error':
        return 'destructive';
      case 'warning':
        return 'warning';
      case 'info':
        return 'outline';
      default:
        return 'outline';
    }
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Alerts & Notifications</h3>
        <div className="flex items-center space-x-2">
          <Icon name="Bell" size={20} className="text-primary" />
          <span className="bg-error text-error-foreground text-xs px-2 py-1 rounded-full">
            {alerts.length}
          </span>
        </div>
      </div>

      <div className="space-y-4">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`border rounded-lg p-4 ${getSeverityColor(alert.severity)}`}
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <Icon name={getAlertIcon(alert.type)} size={20} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium mb-1">{alert.title}</h4>
                <p className="text-sm opacity-90 mb-2">{alert.message}</p>
                <p className="text-xs opacity-70">{alert.timestamp}</p>
              </div>
              
              <div className="flex-shrink-0">
                <Button
                  variant={getActionVariant(alert.severity)}
                  size="sm"
                  className="text-xs"
                >
                  {alert.action}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border flex items-center justify-between">
        <button className="text-sm text-primary hover:text-primary/80 font-medium transition-micro">
          View all alerts
        </button>
        <Button variant="outline" size="sm">
          <Icon name="Settings" size={16} className="mr-2" />
          Alert Settings
        </Button>
      </div>
    </div>
  );
};

export default AlertsPanel;